import { type AggregationFn } from "@tanstack/react-table";
import { format, isValid, parseISO } from "date-fns";

export const minDate: AggregationFn<unknown> = (columnId, leafRows) => {
	let earliest: Date | undefined;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (typeof value !== "string") {
			return;
		}

		try {
			const date = parseISO(value);
			if (!earliest || date < earliest) {
				earliest = date;
			}
		} catch (e) {
			return;
		}
	});
	if (!earliest || !isValid(earliest)) {
		return "";
	}
	return format(earliest, "MM-dd-yyyy");
};
